import { ServiceResponseData } from "./ServiceResponseData";
import { AxiosResponse } from "axios";

export class PaginatedServiceResponseData extends ServiceResponseData {
  paginatedTotalItems: number;

  constructor(response: AxiosResponse) {
    super(response);
    if (response && response.data.Payload) {
      this.paginatedTotalItems = response.data.Payload.PaginatedTotalItems;
    }
  }
}
